import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { TicketCounter } from './ticketCounter.component';
import { selectAreTicketsFull, selectIsGroupExperience } from '../../../../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  areTicketsFull: selectAreTicketsFull,
  isGroupPrice: selectIsGroupExperience,
});

export const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(TicketCounter);
